<section id="how" class="relative scroll-mt-28 overflow-hidden border-t border-surface">
    <app-landing-glow [variant]="3" />
    <div class="relative z-10 mx-auto w-full max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
        <div class="max-w-3xl">
            <div class="text-sm font-semibold uppercase tracking-[0.3em] text-primary">{{ text().howTitle }}</div>
            <div class="mt-4 text-3xl font-semibold text-primary/90 sm:text-4xl dark:text-primary-300">{{ text().howBridgeLine }}</div>
            <h2 class="mt-4 text-3xl font-semibold text-surface-900 sm:text-4xl dark:text-white">{{ text().howSubtitle }}</h2>
        </div>

        <div class="mt-10 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
            @for (step of text().howSteps; track step.title; let i = $index) {
                <div [appRevealOnScroll]="i * 180">
                    <div class="flex h-10 w-10 items-center justify-center rounded-full bg-primary text-sm font-bold text-primary-contrast">{{ i + 1 }}</div>
                    <h3 class="mt-4 text-xl font-semibold text-surface-900 dark:text-white">{{ step.title }}</h3>
                    <p class="mt-3 leading-7 text-muted-color">{{ step.description }}</p>
                </div>
            }
        </div>
    </div>
</section>
